/* eslint-disable id-blacklist */

export default (ctx, inject) => {
  const gtmSendEvent = function(event) {
    if (typeof event === 'string') {
      ctx.$gtm.push({event})
      return
    }

    ctx.$gtm.push(event)

  }

  ctx.$gtmSendEvent= gtmSendEvent
  inject('gtmSendEvent', gtmSendEvent)
}